import "./index.scss";

import useAxios from "axios-hooks";
import jwt_decode from "jwt-decode";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";

import { useAuth } from "@/messenger/providers/AuthProvider";

const Container = ({ children, width = "100%" }: any) => (
    <div style={{ flex: 1, borderLeft: 0, borderRight: 0, maxWidth: width, height: "100vh", paddingTop: 16, boxSizing: "border-box", overflow: "scroll" }}>{children}</div>
  );



const Summary = () : any => {
  
	const { token } = useAuth();
    const decoded = jwt_decode(token);
    const permissions = decoded["permissions"];
    const isAdmin = JSON.stringify(permissions).includes("representative:write") ? true : false;
    
    const [view, setView] = useState("topic");
    //let where = '';

    const handleChange = event => {
        console.log(event.target.value);
        setView(event.target.value);
    };

    const [{ data, loading, error }, sessionContext] = useAxios({
        url: "https://api-aggregate.textkit.statflo.com/v1/graphql",
        method: "POST",
    }, { manual: true });

    
    
    useEffect(() => {
        
        if ((window.location.origin).includes("freedomusa.")) {
            //where = `, where: {identifier: {_nilike: "%statflo.com"}, _and: {identifier: {_nilike: "%torinit.ca"}, _and: {identifier: {_nilike: "%touchless.inc"}}}}`;
        }

        sessionContext({
            data: {
                query: `query getAllCounts {
                    prod_us {
                          
                          CUSTOMERS: representative(distinct_on: customer_id) {
                            customer_id
                            REPRESENTATIVES: all_customer_representatives(order_by: {participant_id: asc}) {
                                participant_id
                                identifier
                                conversations {
                                  conversation_id
                                   messages {
                                    direction
                                    body
                                    sent_at
                                 }
                               }
                             }
                            TOPICS: all_topics {
                              name
                              COHORTS: participants(distinct_on: starts_at) {
                                starts_at
                                REACHED: participant_cohort_aggregate(where: {participants: {category: {last_message_received_at: {_is_null: false}}}}) {
                                  aggregate {
                                    count
                                  }
                                }
                                TO_CONTACT: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "TO_CONTACT"}}}}) {
                                    aggregate {
                                      count
                                    }
                                  }
                                TO_ANSWER: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "TO_ANSWER"}}}}) {
                                  aggregate {
                                    count
                                  }
                                }
                                OPEN: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "OPEN"}}}}) {
                                  aggregate {
                                    count
                                  }
                                }
                                CLOSED: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "CLOSED"}}}}) {
                                  aggregate {
                                    count
                                  }
                                }
                                OPT_OUT: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "OPT_OUT"}}}}) {
                                  aggregate {
                                    count
                                  }
                                }
                              }
                            }
                          }
                    }
                    prod_ca {
                      CUSTOMERS: representative(distinct_on: customer_id) {
                        customer_id
                         REPRESENTATIVES: all_customer_representatives(order_by: {participant_id: asc}) {
                            participant_id
                            identifier
                            conversations {
                                conversation_id
                                messages {
                                    direction
                                    body
                                    sent_at
                                }
                            }
                         }
                         TOPICS: all_topics {
                          name
                          COHORTS: participants(distinct_on: starts_at) {
                            starts_at
                            REACHED: participant_cohort_aggregate(where: {participants: {category: {last_message_received_at: {_is_null: false}}}}) {
                              aggregate {
                                count
                              }
                            }
                            TO_CONTACT: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "TO_CONTACT"}}}}) {
                                aggregate {
                                  count
                                }
                              }
                            TO_ANSWER: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "TO_ANSWER"}}}}) {
                              aggregate {
                                count
                              }
                            }
                            OPEN: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "OPEN"}}}}) {
                              aggregate {
                                count
                              }
                            }
                            CLOSED: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "CLOSED"}}}}) {
                              aggregate {
                                count
                              }
                            }
                            OPT_OUT: participant_cohort_aggregate(where: {participants: {category: {category: {_eq: "OPT_OUT"}}}}) {
                              aggregate {
                                count
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  
                `,
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });
    }, []);

    const representativesUSA = data?.data?.prod_us && data?.data?.prod_us.CUSTOMERS[0]?.REPRESENTATIVES;
    const representativesCanada = data?.data?.prod_us && data?.data?.prod_ca.CUSTOMERS[0]?.REPRESENTATIVES;
    const topicsUSA = data?.data?.prod_ca && data?.data?.prod_us.CUSTOMERS[0]?.TOPICS;
    const topicsCanada = data?.data?.prod_ca && data?.data?.prod_ca.CUSTOMERS[0]?.TOPICS;
    
    let topics = topicsUSA;
    if (topicsCanada?.length > 0 && !topicsUSA?.length){
        topics = topicsCanada;
    }
    let representatives = representativesUSA;
    if (representativesCanada?.length > 0 && !representativesUSA?.length){
        representatives = representativesCanada;
    }
    

	return (
			<div className="c-report_wrapper" >
                   <h1>Reports</h1>
                   {loading && (<p>Loading...</p>)}
                   {error && (<p>Error!</p>)}
                   {topics  && (
                <>
                   <div style={{display: "flex", marginBottom: "16px"}} >
                   <div >
                        <label htmlFor="view">View: </label>
                        <select id="view" onChange={handleChange}>
                        <option value="topic">Topic Results</option>
                        {isAdmin && <option value="detail">Conversation Detail</option>}
                        </select>
                    </div>
                    <div style={{marginLeft: "16px"}}>
                        <label htmlFor="people">People: </label>
                        <select id="people">
                        <option>All</option>
                        </select>
                    </div>
                    
                   </div>
                   <table style={{display: view === "topic" ? "block":"none"}}>
                        <thead>
                            <tr>
                                <td>Topic</td>
                                <td>Cohort</td>
                                <td>Replied</td>
                                <td>To Contact</td>
                                <td>To Answer</td>
                                <td>Open</td>
                                <td>Closed</td>
                                <td>Opt Out</td>
                            </tr>
                        </thead>
                        <tbody>
                        {topics?.map(function(topic, i){ 
                        return (
                            <>
                            {topic.COHORTS.length > 0 &&<tr className="c-report_table_titles">
                                <td style={{width: "15%"}}>{topic.name}</td>
                                <td style={{width: "20%"}}></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>}
                            
                                    
                                    {topic.COHORTS?.map(function(cohort, i){ 
                                            return (
                                                <tr>
                                                <td></td>
                                                <td>{moment(cohort.starts_at).format("lll")}</td>
                                                <td className="statistic">{cohort.REACHED.aggregate.count}</td>
                                                <td className="statistic">{cohort.TO_CONTACT.aggregate.count}</td>
                                                <td className="statistic">{cohort.TO_ANSWER.aggregate.count}</td>
                                                <td className="statistic">{cohort.OPEN.aggregate.count}</td>
                                                <td className="statistic">{cohort.CLOSED.aggregate.count}</td>
                                                <td className="statistic">{cohort.OPT_OUT.aggregate.count}</td>
                                                </tr>
                                            );
                                                                           
                                    })}
                                
                            </>);})}
                        </tbody>
                    </table>
                    {isAdmin && <table style={{display: view === "detail" ? "block":"none"}}>
                        <thead>
                            <tr>
                                <td>Person</td>
                                <td>Conversation</td>
                                <td>Direction</td>
                                <td>Message</td>
                            </tr>
                        </thead>
                        <tbody>
                        {representatives?.map(function(rep, i){ 
                        return (
                            <>
                            {rep.conversations.length > 0 && <tr className="c-report_table_titles">
                                <td style={{width: "15%"}}>{rep.identifier}</td>
                                <td style={{width: "20%"}}></td>
                                <td></td>
                                <td></td>
                            </tr>}
                            
                                    
                                    {rep.conversations.map(function(conversation, i){ 
                                        return (
                                            <>
                                            {conversation?.messages?.length > 0 &&<tr>
                                            <td></td>
                                            <td>{conversation.conversation_id}</td>
                                            <td></td>
                                            <td></td>
                                            </tr>}
                                            {conversation?.messages.map(function(message, i){ 
                                                
                                                const r = /\b(?:\d{4}[ -]?){3}(?=\d{4}\b)/gm
                                                const z = /\b(?:\d{3}\b)/gm
                                                const x = /\b(?:\d{4}\b)/gm
                                                const subst = ` · · · ·`

                                                return (
                                                    <tr>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{message.direction}</td>
                                                    <td>{message.body.replace(r, subst).replace(z, subst).replace(x, subst)}</td>
                                                    </tr>
                                                );
                                                                                    
                                            })}
                                            </>
                                        );
                                                                            
                                    })}
                                
                            </>);})}
                        </tbody>
                    </table>}
                    </>)}
			</div>
	);
};



const Reports = () : any => {

	return (
		<Container>
			<div style={{ height: "100%", boxSizing: "border-box" }}>
				<Summary/>
			</div>
		</Container>
	);
};

export default Reports;